import { z } from 'zod';

import { optionalString, requiredString } from '@/shared/utils/validation';

export const createUpdateUserInputSchema = (isGroupRequired = false) =>
  z.object({
    firstName: requiredString(),
    lastName: requiredString(),
    email: requiredString().email(),
    companyName: optionalString(),
    groupId: isGroupRequired ? requiredString() : optionalString(),
  });
